<template>
  <div>
    <div class="row mb-1">
      <div class="col-sm-6">
        <h4 class="text-uppercase mt-1">
          {{ lexicon.drop_payments }}
        </h4>
      </div>
      <div class="col-sm-6 text-right full-btn">
        <div class="row" v-if="user.admin">
          <div :class="{'col-10':user_id !== '','col-12': user_id === ''}">
            <autocomplete @input="changeUser" v-if="users.length"
                          :placeholder="lexicon.drop_select_customer"
                          :items="users"
            />
          </div>
          <div class="col-2" v-if="user_id !==  ''">
            <button class="btn btn-outline-primary btn-block" @click="showPform()">
              <i class="feather icon-plus-circle"></i>
            </button>
          </div>
        </div>
        <router-link :to="{'name':'payment'}" v-else>
          <button class="btn btn-primary ">
            <i class="feather icon-plus"></i>
            {{ lexicon.drop_top_up }}
          </button>
        </router-link>
      </div>
    </div>
    <section id="paymentsWrapper" class="card">
      <div class="card-content">
        <div class="card-body">
          <div class="card-text">
            <v-client-table :data="tableData" :columns="columns" :options="options" v-if="!loading"
                            class="text">
              <div slot="comment" slot-scope="props">

                <i class="feather icon-info mr-50" @click="e => e.target.classList.toggle('active')"></i>
                <span class="d-inline-block">{{ props.row.comment }}
                  <template v-if="user.admin && props.row.can_refund">
                        <button class="btn btn-success btn-sm can_refund_btn"
                                @click="e => e.target.classList.toggle('active')">{{ lexicon['drop_refund'] }}</button>
                        <div class="can_refund_form">
                          Виконати повернення <span class="text-danger"> {{
                            props.row.cost.toFixed(2)
                          }} {{ lexicon['drop_' + props.row.currency + '_sign'] }}</span>?
                          <div>
                            <button class="btn btn-success btn-sm can_refund_btn mr-1"
                                    @click="e => {e.target.parentNode.parentNode.parentNode.querySelector('.can_refund_btn').classList.toggle('active');refund( props.row.ext_id);props.row.can_refund=false} ">{{
                                lexicon['drop_yes']
                              }}</button>
                            <button class="btn btn-danger btn-sm can_refund_btn"
                                    @click="e => e.target.parentNode.parentNode.parentNode.querySelector('.can_refund_btn').classList.toggle('active')">{{
                                lexicon['drop_no']
                              }}</button>
                          </div>
                        </div>
                  </template>

                </span>
                <span class="table_data_ext_id">
									{{ props.row.ext_id }}
								</span>
                <div class="small" v-if="user.admin">
                  <em>{{ props.row.drop_name }}</em>
                  <div class=" float-right removerAr">
                    <button class="float-end ml-2 btn btn-outline-danger btn-sm px-1"
                            @dblclick="removePay(props.row)">
                      <i class="feather icon-trash-2 font-medium-1"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div slot="cost" slot-scope="props">
                {{ props.row.cost.toFixed(2) }}
                <small class="text-muted">{{ lexicon['drop_' + props.row.currency + '_sign'] }}</small>
              </div>
            </v-client-table>
            <template v-else>
              <div class="text-center">
                <div class="spinner-border text-primary my-5" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </section>
    <div id="addPayModal" ref="addPayModal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog ">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">{{ lexicon.drop_upload_money }}</h4>
            <button type="button" class="close" @click="closePform()">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body ">
            <form action="" @submit.prevent="loadPaybox()">
              <div class="form-group">
                <label class="">{{ lexicon.drop_transaction_num }}:</label>
                <input type="text" :placeholder="lexicon.drop_transaction_num +  ' Paybox'"
                       v-model="paybox_id"
                       class=" form-control " required>
              </div>
              <div class="form-group">
                <button class="btn btn-success btn-block" type="submit">
                  {{ lexicon.drop_find_payment }}
                </button>
              </div>
            </form>
            <template v-if="paybox.success">
              <table class="table table-light">
                <tr>
                  <td class="">{{ lexicon.drop_transaction_num }}</td>
                  <td class="text-primary text-right">{{ paybox.trans_id }}</td>
                </tr>
                <tr>
                  <td class="">{{ lexicon.drop_payment_date }}</td>
                  <td class="text-primary text-right">{{ paybox.created_at }}</td>
                </tr>
                <tr>
                  <td class="">{{ lexicon.drop_amount }}</td>
                  <td class="text-primary text-right">
                    <!--                    <small class="text-muted">{{ paybox.summ }} {{ lexicon.drop_uah_sign }}</small>-->
                    {{ paybox.cost }}{{ lexicon.drop_uah_sign }}
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    {{ paybox.comment }}
                  </td>
                </tr>
              </table>
              <button class="btn  btn-primary btn-block" @click="setPayment()">
                {{ lexicon.drop_upload_cash }}
              </button>
            </template>


          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-dark " data-dismiss="modal" @click="closePform()">
              {{ lexicon.drop_cancel }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show d-none" ref="backdropModal"></div>
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import axios from "axios";
import autocomplete from '../components/UserAutocomplete'
import {Event} from 'vue-tables-2';

export default {
  name: 'payments',
  components: {
    autocomplete
  },
  data() {
    return {
      loading: true,
      paybox_id: '',
      paybox: {},
      user_id: '',
      users: [],
      columns: ["id", "createdon", "cost", "comment", 'ext_id'],
      tableData: [],
      period: [],
      options: {
        sortable: ["id", "cost", "createdon"],
        headings: {
          id: '#',
          createdon: 'Дата',
          cost: 'Сумма',
          comment: 'Описание',
        },
        rowClassCallback(row) {
          return row.active > 0 ? "money-plus " : "money-minus ";
        },
        skin: "table    ",
        dateFormat: 'DD.MM.YYYY HH:mm',
        dateColumns: ['createdon'],
        sortIcon: {base: 'feather', up: 'icon-arrow-up', down: 'icon-arrow-down', is: 'icon-sliders'},
        perPage: 25,
        filterable: true,
        texts: {},
        columnsClasses: {
          'ext_id': 'd-none',
        },
        customFilters: [
          {
            name: 'operation',
            callback: function (row, query) {
              return row.active == query;
            }
          }, {
            name: 'period',
            callback: function (row, query) {
              return row.createdon >= query.start && row.createdon <= query.end;
            }
          },
        ],
      }
    };
  },
  created() {
    this.options.texts = {
      count: this.lexicon.drop_pager_payments,
      first: "First",
      last: "Last",
      filter: this.lexicon.drop_search_input + ":",
      filterPlaceholder: this.lexicon.drop_search_input + " ...",
      limit: this.lexicon.drop_show_till,
      page: this.lexicon.drop_page,
      noResults: this.lexicon.drop_no_results,
      filterBy: this.lexicon.drop_col_filter,
      loading: this.lexicon.drop_loading,
      defaultOption: this.lexicon.drop_selected_col,
      columns: this.lexicon.drop_columns,
    }
    this.options.headings = {
      id: '#',
      createdon: this.lexicon.drop_date,
      cost: this.lexicon.drop_amount,
      comment: this.lexicon.drop_description,
    }
    Event.$on('wait-period', this.changePeriod)
    this.fetchData()
    if (this.user.admin) {
      this.usersData()
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
    ...mapState({
      lexicon: 'lexicon',
    })
  },
  watch: {
    $route: 'fetchData'
  },
  methods: {
    fetchData() {
      this.loading = true

      let reqData = {};
      if (this.user.admin) {
        reqData = {'period': this.period, 'user_id': this.user_id};
      }
      axios.post('payments/', reqData).then((response) => {
        this.loading = false
        const list = response.data.data.list
        // console.log(list)
        const len = list.length
        this.tableData = list.map(function (obj, index) {
          obj.id = len - index;
          obj.active = parseInt(obj.active);
          obj.cost = parseFloat(obj.active > 0 ? obj.cost : (obj.cost * -1))
          obj.createdon = window.moment(obj.createdon);
          return obj;
        });
        if (this.tableData.length > 0) {
          this.period = [window.moment(this.tableData.slice(-1).pop().createdon).format('YYYY-MM-DD'), window.moment(this.tableData.slice(0, 1).pop().createdon).format('YYYY-MM-DD')]
        }
      })
    },
    changePeriod() {
      Event.$emit('change-period', this.period);
    },
    usersData() {
      axios.get('users/').then((response) => {
        this.users = response.data.data
      })
    },
    changeUser(value) {
      this.user_id = value.ref
      this.fetchData()
    },
    showPform() {
      this.$refs['backdropModal'].classList.remove('d-none')
      this.$refs['addPayModal'].classList.add('show')
      this.$refs['addPayModal'].classList.add('d-block')
      var a = document.body;
      a.classList.add('modal-open')
    },
    closePform() {
      this.$refs['backdropModal'].classList.add('d-none')
      this.$refs['addPayModal'].classList.remove('show')
      this.$refs['addPayModal'].classList.remove('d-block')
      var a = document.body;
      a.classList.remove('modal-open')
    },
    setPayment() {
      // console.log(this.paybox)
      this.paybox.user_id = this.user_id;
      axios.post('payments/set/', {"payment": this.paybox}).then((response) => {
        let data = response.data
        // console.log(response)
        if (data.success) {
          this.paybox_id = '';
          this.paybox = {};
          this.closePform();
        }
      })
    },
    refund(ext) {
      axios.get('payments/correction/?id=' +ext)
    },
    loadPaybox() {
      this.paybox = {}
      axios.get('payments/paybox/?id=' + this.paybox_id).then((response) => {
        let data = response.data
        if (data.success && data.data && data.data.success) {
          this.paybox = data.data;
        }
      })
    },
    removePay(payment) {
      // this.paybox = {}
      axios.get('payments/remove/?id=' + payment.ext_id).then((response) => {
        let data = response.data
        if (data.success && data.data) {
          this.fetchData()
        }
      })
    }
  }
}
</script>

<style>
#addPayModal .modal-header .close {
  padding: .2rem .62rem;
  margin: 0;
}

.removerAr {
  width: 20px;
  overflow: hidden;
}

.can_refund_form, .can_refund_btn.active {
  display: none;

}

.can_refund_btn.active + .can_refund_form {
  display: block;
}

.removerAr:hover {
  width: auto;
}
</style>